<script setup lang="ts">
	import { useBasePrinter } from './BasePrinter.js';
	import {ref, computed, onMounted, nextTick} from 'vue';
	
	const props = defineProps({
		value: String,
		style: String,
		styleClass: String,
		//styleId: String,
		//link: String,
		//linkTarget: String,
		//tooltip: String,
		sortStyle: Object,
		modelValue: Number,
		rowValue: Number,
		restApi: String
	});
	
	const sequenceId = ref(null);
	const sequence = ref(0);
	const error = ref(false);
	const editMode = ref(false);
	const {hasLink, tdStyle} = useBasePrinter(props);
	
	const emit = defineEmits(['emitError','update:modelValue','update:rowValue']);

	function save(): void {
		if (editMode.value) { //to number
			if (Number.isNaN(sequence.value)) {
				sequence.value=parseInt(props.rowValue);
			}
			else if (sequence.value==="" || sequence.value===null) {
				sequence.value=0;
			}

			sendData().then(() => {
				editMode.value=false;
				emit('update:modelValue', sequence.value);
				emit('update:rowValue', sequence.value);
			});
		}
	}
		
	function escape(): void {
		//console.log("esc pressed");
		sequence.value=props.modelValue;
		editMode.value=false;
	}
		
	function edit(): void {
		editMode.value=true;
		sequence.value=props.modelValue;//parseInt(props.modelValue);
		nextTick().then(()=>{
			sequenceId.value.focus();
		});
	}
	
	function sendData(): void {
		emit("emitError","");
		//console.log("seq:"+this.sequence+" rest:"+this.restApi);
		return fetch(props.restApi, { 
			method: 'PATCH' ,
			body: JSON.stringify({
				sequence: sequence.value
			}),
			headers: { 'Content-type': 'application/json; charset=UTF-8'}
		})
		.then(response => {
			if (!response.ok) {
				console.error('Error:', response.status);
				emit("emitError","RestApi point return status:"+response.status);
			}
		})
		.catch((error) => {
			console.error('Error:', error);
			emit("emitError","Error to fetch restApi point");
		});
	}
</script>
<template>
	<td :class="styleClass" :style="[sortStyle, tdStyle]">
		<span v-if="editMode" >
			<input type="number" min="0" max="999" ref="sequenceId" v-model.number="sequence" size="5"
				   @focusout="save" @keyup.enter="save" @keyup.esc="escape">
		</span>
		<span v-else style="cursor: pointer;" @click="edit">{{modelValue}}</span>
	</td>
</template>
